module.exports = __webpack_public_path__ + "static/img/img_4.c9d6d995.jpg";